import { z } from 'zod';

export const schemaApiCategories = z.enum(['notes', 'communication', 'documents', 'status', 'legitimation']);

export const schemaGeneralEventApiResponse = z.object({
    _issuerName: z.string().optional(),
    aggregateId: z.string().uuid(),
    aggregateVersion: z.number().int(),
    category: schemaApiCategories.optional(),
    causationId: z.string().uuid().nullable(),
    correlationId: z.string().uuid(),
    id: z.string(),
    payload: z.any(),
    position: z.number().int(),
    timestamp: z.number().int(),
    type: z.string(),
});

export type GeneralEventApiResponse = z.infer<typeof schemaGeneralEventApiResponse>;
export type SchemaApiCategories = z.infer<typeof schemaApiCategories>;
